import styled from 'styled-components';
import { StyledButton } from '../../../CommonComponents/Button';
import { darkBg, loadingAnimation } from '../../../CommonComponents/LoadingMask';
import { TableBody } from '../../../OrionOnboarding/OrionOnboardingStyles';

export const Title = styled.div`
  margin-bottom: 40px;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.19px;
  color: #000000;
  display: flex;
`;

export const LinkButton = styled(StyledButton.Link)`
  color: #5abee4;
  vertical-align: middle;
  display: inline-block;
  margin-left: 5px;
`;

export const TableContainer = styled.div`
  max-width: 600px;
  min-height: 300px;
  position: relative;
  ${TableBody} {
    max-height: calc(100vh - 480px);
  }
  ${props => {
    if (!props.hasLoaded) {
      return `
        &:after {
          border-radius: 15px;
          bottom: 0;
          content: '';
          height: 100%;
          position: absolute;
          top: 0;
          width: 100%;
          z-index: 99;
          ${darkBg}
          ${loadingAnimation}
        }

        &:before {
          background: #fff;
          bottom: 0;
          content: '';
          height: 100%;
          position: absolute;
          top: 0;
          width: 100%;
          z-index: 98;
        }
      `;
    }
    return ``;
  }}
`;
